import { Link } from "react-router-dom";
import HeroCar from "../images/plan/main.png";
import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';

function Hero() {
  const { t } = useTranslation();
  const [goUp, setGoUp] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: (0, 0), behavior: "smooth" });
  };

  const bookBtn = () => {
    document
      .querySelector("#booking-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const onPageScroll = () => {
      if (window.pageYOffset > 600) {
        setGoUp(true);
      } else {
        setGoUp(false);
      }
    };
    window.addEventListener("scroll", onPageScroll);

    return () => {
      window.removeEventListener("scroll", onPageScroll);
    };
  }, []);
  return (
    <>
      <section id="home" className="hero-section">
        <div className="container">

          <div className="hero-content">
            <div className="hero-content__text">
              <h4>{t('hero.subtitle')}</h4>
              <h1>
                <span>{t('hero.title.part1')}</span> {t('hero.title.part2')}
              </h1>
              <p>{t('hero.description')}</p>
              <div className="hero-content__text__btns">
                <Link
                  onClick={bookBtn}
                  className="hero-content__text__btns__book-ride"
                  to="/"
                >
                  {t('hero.button')} &nbsp; <i className="fa-solid fa-circle-check"></i>
                </Link>

              </div>
            </div>

            {/* img */}
            <img
              src={HeroCar}
              alt="car-img"
              className="hero-content__car-img"
              style={{
                width: "60%",
                position: "relative",
                zIndex: "1"
              }}
            />
            <div
              style={{
                position: "absolute",
                width: "60%",
                height: "100%",
                right: "0",
                top: "50%",
                transform: "translateY(-50%)",
                background: "rgba(255, 76, 48, 0.26)",
                borderRadius: "50%",
                filter: "blur(200px)",
                zIndex: "0"
              }}
            ></div>
          </div>
        </div>

        {/* page up */}
        <div
          onClick={scrollToTop}
          className={`scroll-up ${goUp ? "show-scroll" : ""}`}
        >
          <i className="fa-solid fa-angle-up"></i>
        </div>
      </section>
    </>
  );
}

export default Hero;
